import * as Sentry from "@sentry/react"
import { FC, ReactNode } from "react"
import { DefaultError } from "./ui/DefaultError/DefaultError"

interface ErrorBoundaryProps {
  children: ReactNode
}

/**
 * Error Boundary component integrated with Sentry
 * Automatically captures and reports errors to Sentry
 */
export const ErrorBoundary: FC<ErrorBoundaryProps> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <DefaultError
          error={error instanceof Error ? error : new Error(String(error))}
        />
      )}
      onError={(error, componentStack) => {
        console.log("===Error caught!===")
        console.error(error)
        console.error(componentStack)
        console.log("==================")
      }}
      showDialog={false} // Set to true to show Sentry's feedback dialog
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
